import React from 'react';
import useFetch from '../../hooks/useFetch';

const UserAnnouncementsPage = () => {
    // Backend'de veri yoksa boş dizi döner
    const { data: announcements, loading } = useFetch('/extras/announcements');

    return (
        <div className="space-y-6">
            <h1 className="text-3xl font-bold text-text-primary">Duyurular</h1>
            
            {loading ? <p className="text-white">Yükleniyor...</p> : (
                <div className="grid gap-4">
                    {announcements && announcements.length > 0 ? announcements.map(ann => (
                        <div key={ann._id} className="bg-surface p-6 rounded-xl shadow-lg border-l-4 border-primary">
                            <div className="flex justify-between items-start mb-2">
                                <h3 className="text-xl font-bold text-white">{ann.title}</h3>
                                <span className="text-xs text-text-secondary">{new Date(ann.createdAt).toLocaleDateString()}</span>
                            </div>
                            <p className="text-text-secondary">{ann.content}</p>
                        </div>
                    )) : (
                        <div className="bg-surface p-6 rounded-xl text-center text-text-secondary">
                            Henüz bir duyuru yayınlanmamış.
                        </div>
                    )}
                </div>
            )}
        </div>
    );
};
export default UserAnnouncementsPage;